import { apiRequest } from "./ApiUtility";

export async function getAllPredefinedText(authContext) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/predefinedtext/getall/${authContext.selectedFacility.id}`;
  return await apiRequest("get", url, authContext);
}

export async function createPredefinedText(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/predefinedtext/create`;
  return await apiRequest("post", url, authContext, data);
}

export async function updatePredefinedTextById(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/predefinedtext/update/${data.id}`;
  return await apiRequest("put", url, authContext, data);
}

export async function deletePredefinedTextById(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/predefinedtext/delete/${id}`;
  return await apiRequest("delete", url, authContext, id);
}

export async function getPredefinedTextById(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/predefinedtext/getbyid/${id}`;
  return await apiRequest("get", url, authContext, id);
}